// src/theme/colors.js
export const colorTheme = {
  // Primary Brand Color (Orange) - #f58025
  brand: {
    light: '#fbd1ad',   // 200
    main: '#f58025',    // 500 - Your exact color
    dark: '#e66610',    // 600
    gradientTo: '#f6a55a',   // warm amber — brand orange → golden fade
    text: 'text-brand-600',
    bg: 'bg-brand-50',
    border: 'border-brand-500',
    hover: 'hover:bg-brand-100',
    gradient: 'from-brand-50 to-brand-100',
    textKpi: 'text-brand-700',
    borderKpi: 'border-brand-500',
    bgChart: 'bg-brand-500',
    bgSolid: 'bg-brand-500',
    bgLight: 'bg-brand-200',
    textLight: 'text-brand-300',
    textDark: 'text-brand-800',
    borderLight: 'border-brand-200',
    shadow: 'shadow-brand-100'
  },

  // Dark Blue - #152451
  darkblue: {
    light: '#cdd6e6',   // 200
    main: '#152451',    // 500 - Your exact color
    dark: '#11203f',    // 600
    gradientTo: '#0093cf',   // ← brightblue.main — matches the reference card exactly
    text: 'text-darkblue-500',
    bg: 'bg-darkblue-50',
    border: 'border-darkblue-500',
    hover: 'hover:bg-darkblue-100',
    gradient: 'from-darkblue-50 to-darkblue-100',
    textKpi: 'text-darkblue-700',
    borderKpi: 'border-darkblue-500',
    bgChart: 'bg-darkblue-500',
    bgSolid: 'bg-darkblue-500',
    bgLight: 'bg-darkblue-200',
    textLight: 'text-darkblue-300',
    textDark: 'text-darkblue-800',
    borderLight: 'border-darkblue-200',
    shadow: 'shadow-darkblue-100'
  },

  // Violet - #92278F
  violet: {
    light: '#ebd8ea',   // 200
    main: '#92278f',    // 500 - Your exact color
    dark: '#7d2179',    // 600
    gradientTo: '#c77ec2',   // light violet — deep violet → soft orchid
    text: 'text-violet-600',
    bg: 'bg-violet-50',
    border: 'border-violet-500',
    hover: 'hover:bg-violet-100',
    gradient: 'from-violet-50 to-violet-100',
    textKpi: 'text-violet-700',
    borderKpi: 'border-violet-500',
    bgChart: 'bg-violet-500',
    bgSolid: 'bg-violet-500',
    bgLight: 'bg-violet-200',
    textLight: 'text-violet-300',
    textDark: 'text-violet-800',
    borderLight: 'border-violet-200',
    shadow: 'shadow-violet-100'
  },

  // Teal - #009391
  teal: {
    light: '#a7fffa',   // 200
    main: '#009391',    // 500 - Your exact color
    dark: '#007876',    // 600
    gradientTo: '#24f4eb',   // electric teal — deep teal → neon mint
    text: 'text-teal-600',
    bg: 'bg-teal-50',
    border: 'border-teal-500',
    hover: 'hover:bg-teal-100',
    gradient: 'from-teal-50 to-teal-100',
    textKpi: 'text-teal-700',
    borderKpi: 'border-teal-500',
    bgChart: 'bg-teal-500',
    bgSolid: 'bg-teal-500',
    bgLight: 'bg-teal-200',
    textLight: 'text-teal-300',
    textDark: 'text-teal-800',
    borderLight: 'border-teal-200',
    shadow: 'shadow-teal-100'
  },

  // Yellow - #FFDD00
  yellow: {
    light: '#fff786',   // 200
    main: '#ffdd00',    // 500 - Your exact color
    dark: '#d1a800',    // 600
    gradientTo: '#ffe94d',   // lighter gold — saturated yellow → bright lemon
    text: 'text-yellow-600',
    bg: 'bg-yellow-50',
    border: 'border-yellow-500',
    hover: 'hover:bg-yellow-100',
    gradient: 'from-yellow-50 to-yellow-100',
    textKpi: 'text-yellow-700',
    borderKpi: 'border-yellow-500',
    bgChart: 'bg-yellow-500',
    bgSolid: 'bg-yellow-500',
    bgLight: 'bg-yellow-200',
    textLight: 'text-yellow-300',
    textDark: 'text-yellow-800',
    borderLight: 'border-yellow-200',
    shadow: 'shadow-yellow-100'
  },

  // Bright Blue - #0093CF
  brightblue: {
    light: '#b9e5fe',   // 200
    main: '#0093cf',    // 500 - Your exact color
    dark: '#0078ab',    // 600
    gradientTo: '#64bfe8',   // sky blue — medium blue → soft sky
    text: 'text-brightblue-600',
    bg: 'bg-brightblue-50',
    border: 'border-brightblue-500',
    hover: 'hover:bg-brightblue-100',
    gradient: 'from-brightblue-50 to-brightblue-100',
    textKpi: 'text-brightblue-700',
    borderKpi: 'border-brightblue-500',
    bgChart: 'bg-brightblue-500',
    bgSolid: 'bg-brightblue-500',
    bgLight: 'bg-brightblue-200',
    textLight: 'text-brightblue-300',
    textDark: 'text-brightblue-800',
    borderLight: 'border-brightblue-200',
    shadow: 'shadow-brightblue-100'
  },

  // Pink - #ED145B
  pink: {
    light: '#ffcce3',   // 200
    main: '#ed145b',    // 500 - Your exact color
    dark: '#d1104e',    // 600
    gradientTo: '#f06a96',   // rose — deep red-pink → soft rose
    text: 'text-pink-600',
    bg: 'bg-pink-50',
    border: 'border-pink-500',
    hover: 'hover:bg-pink-100',
    gradient: 'from-pink-50 to-pink-100',
    textKpi: 'text-pink-700',
    borderKpi: 'border-pink-500',
    bgChart: 'bg-pink-500',
    bgSolid: 'bg-pink-500',
    bgLight: 'bg-pink-200',
    textLight: 'text-pink-300',
    textDark: 'text-pink-800',
    borderLight: 'border-pink-200',
    shadow: 'shadow-pink-100'
  },

  // Green - #B0BC22
  green: {
    light: '#e3f09d',   // 200
    main: '#b0bc22',    // 500 - Your exact color
    dark: '#8a9518',    // 600
    gradientTo: '#d4dd5e',   // lime — olive green → bright lime
    text: 'text-green-600',
    bg: 'bg-green-50',
    border: 'border-green-500',
    hover: 'hover:bg-green-100',
    gradient: 'from-green-50 to-green-100',
    textKpi: 'text-green-700',
    borderKpi: 'border-green-500',
    bgChart: 'bg-green-500',
    bgSolid: 'bg-green-500',
    bgLight: 'bg-green-200',
    textLight: 'text-green-300',
    textDark: 'text-green-800',
    borderLight: 'border-green-200',
    shadow: 'shadow-green-100'
  },

  // Grey - #DCDEEF (at 300 since it's quite light)
  grey: {
    light: '#f1f2f8',   // 100
    main: '#dcdeef',    // 300 - Your exact color
    dark: '#a5abc9',    // 500
    gradientTo: '#f1f2f8',   // near-white — neutral grey → very light
    text: 'text-grey-600',
    bg: 'bg-grey-50',
    border: 'border-grey-300',
    hover: 'hover:bg-grey-100',
    gradient: 'from-grey-50 to-grey-100',
    textKpi: 'text-grey-700',
    borderKpi: 'border-grey-500',
    bgChart: 'bg-grey-500',
    bgSolid: 'bg-grey-500',
    bgLight: 'bg-grey-200',
    textLight: 'text-grey-300',
    textDark: 'text-grey-800',
    borderLight: 'border-grey-200',
    shadow: 'shadow-grey-100'
  }
};

// Global theme settings for components
export const componentThemes = {
  card: {
    background: 'bg-grey-100',
    border: 'border-grey-300',
    shadow: 'shadow-sm',
    rounded: 'rounded-xl',
    padding: 'p-6'
  },
  text: {
    heading: 'text-darkblue-500',
    subheading: 'text-darkblue-700',
    body: 'text-grey-700',
    muted: 'text-grey-500',
    light: 'text-grey-300'
  },
  interactive: {
    hover: 'hover:opacity-80',
    transition: 'transition-opacity',
    cursor: 'cursor-pointer'
  }
};

// Utility function to get color by name
export const getColor = (colorName) => {
  return colorTheme[colorName] || colorTheme.brand;
};

// Chart-specific color utilities
export const getChartColors = (colorNames) => {
  return colorNames.map(colorName => {
    const color = getColor(colorName);
    return color.main;
  });
};

// Get light background colors for teams
export const getLightChartColors = (colorNames) => {
  return colorNames.map(colorName => getColor(colorName).bgLight);
};

// Get colors by intensity
export const getColorsByIntensity = (colorNames, intensity = 'normal') => {
  return colorNames.map(colorName => {
    const color = getColor(colorName);
    switch(intensity) {
      case 'light': return color.bgLight;
      case 'dark': return color.bgSolid;
      case 'normal':
      default: return color.bgChart;
    }
  });
};

// Background colors array for charts
export const backgroundColors = {
  colors: [
    'bg-brand-500',
    'bg-brightblue-500',
    'bg-violet-500',
    'bg-teal-500',
    'bg-pink-500',
    'bg-green-500'
  ],
  team: ['brand', 'brightblue', 'violet', 'teal', 'pink', 'green'].map(color => getColor(color).bgChart),
  offers: ['green', 'teal', 'yellow', 'brightblue', 'pink'].map(color => getColor(color).bgChart)
};

// Pre-defined color schemes for different use cases
export const colorSchemes = {
  kpi: ['brand', 'pink', 'darkblue', 'brightblue', 'green', 'teal'],
  performance: ['green', 'brightblue', 'violet', 'brand'],
  team: ['brand', 'brightblue', 'violet', 'teal', 'pink', 'green'],
  teamLight: ['brand', 'brightblue', 'violet', 'teal', 'pink', 'green'],
  teamCustom: [
    'bg-brand-200',
    'bg-brightblue-200',
    'bg-violet-200',
    'bg-teal-200',
    'bg-pink-200',
    'bg-green-200'
  ],
  offerTypes: ['green', 'teal', 'yellow', 'brightblue', 'pink'],
  status: {
    success: 'green',
    warning: 'yellow',
    error: 'pink',
    info: 'brightblue',
    neutral: 'grey'
  },
  charts: ['brand', 'brightblue', 'violet', 'teal', 'pink', 'green', 'yellow', 'darkblue']
};

// Offer types configuration with theme colors
export const offerTypesConfig = [
  { name: 'WS25K', color: 'green' },
  { name: 'WS20K', color: 'teal' },
  { name: 'MM7K', color: 'yellow' },
  { name: 'MM5K', color: 'brightblue' },
  { name: 'MN3K', color: 'pink' }
];

// KPI-specific configuration
export const kpiConfig = [
  {
    key: 'total_calls',
    title: 'Total Calls',
    color: 'brand',
    fallbackKeys: ['total_calls']
  },
  {
    key: 'show_rate',
    title: 'Show Rate',
    color: 'pink',
    isPercentage: true,
    fallbackKeys: ['show_rate']
  },
  {
    key: 'deals_offered',
    title: 'Offers Made',
    color: 'darkblue',
    fallbackKeys: ['deals_offered', 'appointments_offered']
  },
  {
    key: 'deals_closed',
    title: 'Deals Closed',
    color: 'brightblue',
    fallbackKeys: ['deals_closed']
  },
  {
    key: 'opportunity_value',
    title: 'Opportunity Value',
    color: 'green',
    isMillions: true,
    fallbackKeys: ['opportunity_value']
  },
  {
    key: 'conversion_rate',
    title: 'Conversion Rate',
    color: 'teal',
    isPercentage: true,
    fallbackKeys: ['conversion_rate']
  }
];

// Theme variants for different contexts
export const themeVariants = {
  light: {
    background: 'bg-white',
    surface: 'bg-grey-50',
    text: {
      primary: 'text-darkblue-500',
      secondary: 'text-grey-600',
      muted: 'text-grey-400'
    },
    border: 'border-grey-300'
  },
  dark: {
    background: 'bg-darkblue-900',
    surface: 'bg-darkblue-800',
    text: {
      primary: 'text-white',
      secondary: 'text-grey-300',
      muted: 'text-grey-500'
    },
    border: 'border-darkblue-700'
  }
};